import axios from "axios";
import { Flip, toast } from "react-toastify";

export const ResetPassword = async (data) => {
    try {
        const response = await axios.post(
            process.env.REACT_APP_RESET_PASSWORD_URL,
            data
        );

        if (response) {
            return response;
        }
    } catch (error) {
        console.error("Error during API call:", error.message);

        toast.error(
            error.response?.data?.message || error.message,
            {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
            }
        );

        return error.response;
    }
};